import React, { useState } from "react";

import { string, object, arrayOf, oneOfType } from "prop-types";
import { connect } from "react-redux";

import { getByPath } from "../helpers/utils";

const computeStyle = ({ minimised }) => ({
  container: {
    background: "lightyellow",
    position: "fixed",
    overflowX: "hidden",
    overflowY: "hidden",
    bottom: minimised ? 10 : 10,
    width: minimised ? 50 : 500,
    height: minimised ? 25 : 500,
    zIndex: 50000,
  },
  headerLine: {
    display: "flex",
  },
  link: {
    cursor: "pointer",
    color: "blue",
  },
  logs: {
    position: "relative",
    overflowY: minimised ? "hidden" : "scroll",
    height: minimised ? 0 : 500,
  },
});

const isExternal = (err) =>
  getByPath("response.data.baseURL", err) ===
  "https://profileapimanager.azurewebsites.net/p1";

const LogViewer = ({ errors }) => {
  const [{ minimised }, setState] = useState({ minimised: true });

  const toggleMinimised = () => {
    setState({ minimised: !minimised });
  };

  const style = computeStyle({ minimised });

  const copy = (index) => () =>
    navigator.clipboard.writeText(JSON.stringify(errors[index].error, null, 2));

  const copyAll = () =>
    navigator.clipboard.writeText(JSON.stringify(errors, null, 2));

  return (
    <div style={style.container}>
      <div>
        <span style={style.link} onClick={toggleMinimised}>
          {minimised ? "[+]" : "[-]"}
        </span>{" "}
        {errors.length}{" "}
        <span style={style.link} onClick={copyAll}>
          Copy All
        </span>
      </div>
      <div style={style.logs}>
        {errors.map(({ error }, i) => (
          <div key={`error_${i}`}>
            <div style={style.headerLine}>
              <h4>
                Error {i + 1} -{" "}
                {isExternal(error) ? "[External Server]" : "[Our Server]"}
              </h4>
              <div style={style.link} onClick={copy(i)}>
                Copy
              </div>
            </div>
            <pre>{JSON.stringify(error, null, 2)}</pre>
            <hr />
          </div>
        ))}
      </div>
    </div>
  );
};

LogViewer.propTypes = {
  errors: arrayOf(oneOfType([string, object])),
};

const mapStateToProps = ({ core: { errors } }) => {
  return { errors: errors || [] };
};

export default connect(mapStateToProps, null)(LogViewer);
